﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';
import * as FilePond from 'filepond';

require('fontawesome-iconpicker');

import * as Entities_Empty from '../../../../lib/entities/empty';
import * as Entities_Memory_Position from '../../../entities/memoryposition';

import FilePondPluginFileEncode from '../../../plugins/filepond-plugin-file-encode';
import FilePondPluginImageCrop from '../../../plugins/filepond-plugin-image-crop';
import FilePondPluginImageResize from '../../../plugins/filepond-plugin-image-resize';
import FilePondPluginImageTransform from '../../../plugins/filepond-plugin-image-transform';
import FilePondPluginImagePreview from '../../../plugins/filepond-plugin-image-preview';
import FilePondPluginImageEdit from '../../../plugins/filepond-plugin-image-edit';

import View_MenuSingleList from './menuSingleList';

import helper_infopage from '../../../helper/infopage';

import config from '../../../../common/config';

import tpl_menuSingle from './tpl/menuSingle.html';

export default Marionette.LayoutView.extend({
    dialogRegion: '#menuSingle_modal',
    errors: [],
    getTemplate: function () {
        return tpl_menuSingle({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    regions: {
        menuSingleList: "#menuSingleListA"
    },
    onBeforeShow: function () {
        this.menuSingleList.show(new View_MenuSingleList({ app: this.app, collection: this.collection }));
        //this.htmlListPagination.show(new View_Pagination({ collection: this.collection }));
    },
    ui: {
        'menuSingle_dropDown_MenuItem': '#menuSingle_dropDown_MenuItem',
        'menuSingle_dropDown_GridMenuType': '#menuSingle_dropDown_GridMenuType',
        'menuSingle_btn_icon': '#menuSingle_btn_icon',
        'menuSingle_btn_icon_selected': '#menuSingle_btn_icon_selected',
        'menuSingle_btn_icon_selected_i': '#menuSingle_btn_icon_selected_i',
        'menuSingle_dropDown_GridMenuType': '#menuSingle_dropDown_GridMenuType',

        'menuSingle': '#menuSingle',
        'menuSingle_input_margin1_Top': '#menuSingle_input_margin1_Top',
        'menuSingle_input_margin1_Bottom': '#menuSingle_input_margin1_Bottom',
        'menuSingle_input_margin1_Left': '#menuSingle_input_margin1_Left',
        'menuSingle_input_margin1_Right': '#menuSingle_input_margin1_Right',
        
        'menuSingle_filePond': '#menuSingle_filePond',

        'menuSingle_btn01': '#menuSingle_btn01',
        'menuSingle_btn02': '#menuSingle_btn02'
    },
    events: {
        'iconpickerSelected @ui.menuSingle_btn_icon': 'iconSelected_menuSingle_btn_icon',
        'change @ui.menuSingle_select_Font1_FontType': 'change_Font1_FontType',
        'change @ui.menuSingle_select_Font1_ColorType': 'change_Font1_ColorType',
        'colorpickerChange @ui.menuSingle_ColorPickerSliders_Font1_Color': 'colorChange_Font1Color',
        'click @ui.menuSingle_btn01': 'onBtn01',
        'click @ui.menuSingle_btn02': 'onBtn02'
    },
    onRender: function () {
    },
    //getCollectionNextPosition: function () {
    //    var ret = 0;
    //    this.collection.forEach(function (entry) {
    //        if (entry.attributes.id >= ret) {
    //            ret = entry.attributes.id;
    //        }
    //    });
    //    return ret+1;
    //},
    nextCollectionId() {
        var ret = 0;
        this.collection.forEach(function (entry) {
            if (entry.id > ret) ret = entry.id;
        });

        return ret;
    },
    reOrder() {
        var self = this;
        var position = 0;
        $('#pictureListItem.myDiv').each(function (index, item) {
            var id = parseInt($(item).attr('data-id'));
            if (id != undefined) {
                var model = self.collection.where({ id: id })[0];
                model.set({ Position: position });
                $(item).attr('data-position', position);
                position++;
            }
        });
    },
    onAttach() {
        var self = this;

        this.setupMenuSingleType();
        this.setupFontawesome_iconpicker();
        this.setupMenuItem();

        FilePond.registerPlugin(
            FilePondPluginFileEncode,
            FilePondPluginImageCrop,
            FilePondPluginImageResize,
            FilePondPluginImageTransform,
            FilePondPluginImagePreview,
            FilePondPluginImageEdit,

        );

        var labelIdle = resources.X101435 + ' <span class="filepond--label-action">' + resources.X101437 + '</span>';

        var pond = FilePond.create(this.ui.menuSingle_filePond[0], {
            labelIdle: [
                labelIdle,
                ''
            ],
            allowMultiple: true,
            //allowReorder: true,
            //allowFileEncode: true,
            //allowImageCrop: true,
            //imageCropAspectRatio:"1:1",
            allowImageResize: true,
            imageResizeTargetWidth: 750,
            imageResizeTargetHeight: 750,
            imageResizeMode: 'contain',
            imageResizeUpscale: true,
            //imageCropAspectRatio: 1,
            allowImageTransform: true,
            //allowImagePreview: true,
            //allowImageEdit:true,

            onaddfile: (err, fileItem) => {
                if (err == null) {
                    //console.log(err, fileItem.getMetadata('resize'));
                    var base64 = fileItem.getFileEncodeDataURL();
                    //var base64 = fileItem.getFileEncodeBase64String();

                    var canvas = document.createElement('canvas');
                    canvas.width = 750;
                    canvas.height = 750;

                    var context = canvas.getContext('2d');

                    var image = new Image();
                    image.src = base64;

                    image.onload = function () {
                        canvas.width = image.width;
                        canvas.height = image.width;

                        var wrh = image.width / image.width;
                        var newWidth = canvas.width;
                        var newHeight = newWidth / wrh;
                        if (newHeight > canvas.height) {
                            newHeight = canvas.height;
                            newWidth = newHeight * wrh;
                        }
                        var xOffset = newWidth < canvas.width ? ((canvas.width - newWidth) / 2) : 0;
                        var yOffset = newHeight < canvas.height ? ((canvas.height - newHeight) / 2) : 0;

                        /* force original size */
                        newWidth = image.width;
                        newHeight = image.height;
                        xOffset = 0;
                        yOffset = 0;
                        canvas.width = image.width;
                        canvas.height = image.height;
                        /* force original size */

                        context.beginPath();
                        //context.fillStyle = "white";
                        //context.fillRect(0, 0, canvas.width, canvas.height);
                        context.drawImage(image, xOffset, yOffset, newWidth, newHeight);

                        base64 = canvas.toDataURL();

                        //self.collection.reset();

                        var defaultModel = self.app.entities.collections.Module.where({ id: 10 })[0];

                        var tmpModel = new Entities_Memory_Position.Model();
                        //tmpModel.attributes.OrgImage = base64;
                        //tmpModel.attributes.Image = base64;

                        //tmpModel.attributes.OrgImage = "";
                        //tmpModel.attributes.Image = "";

                        tmpModel.attributes.Selected = true;
                        //var id = self.nextCollectionId() + 1;
                        /*tmpModel.id = 1;
                        tmpModel.attributes.id = 1;
                        tmpModel.attributes.Position = 1;*/

                        /*tmpModel.attributes.Animation = defaultModel.attributes.Data.Model.Animation;
                        tmpModel.attributes.Text = defaultModel.attributes.Data.Model.Text;
                        tmpModel.attributes.Duration = defaultModel.attributes.Data.Model.Duration;*/

                        var searchString = ";base64,";
                        var pos = base64.indexOf(searchString);
                        var imageMime = base64.substring(5, pos);
                        var imageData = base64.substring(pos + searchString.length, base64.length);

                        //self.reOrder();

                        var callbackSaveImage = function (model) {
                            tmpModel.attributes.Position = model.attributes.id;
                            tmpModel.attributes.id = model.attributes.id;
                            tmpModel.attributes.InfoImage_id = model.attributes.id;
                            tmpModel.attributes.InfoImage_ImageUrl = model.attributes.ImageUrl;
                            tmpModel.attributes.InfoImage_Name = model.attributes.Name;

                            /*tmpModel.attributes.ImageUrl = model.attributes.ImageUrl;
                            tmpModel.attributes.CommonId = model.attributes.CommonId;
                            tmpModel.attributes.id = model.attributes.id;*/

                            self.collection.add(tmpModel);
                            pond.removeFile(fileItem);

                            //Remove old model in both this collection and CustomImageInfo
                            self.collection.forEach(function (entry) {
                                var customInfoImageModel = self.app.entities.collections.customInfoImage.where({ id: entry.attributes.id })[0];
                                if (customInfoImageModel != undefined && customInfoImageModel.attributes.id != model.attributes.id) {

                                    var collection = self.app.entities.collections.customInfoImage;

                                    customInfoImageModel.destroy({
                                        wait: true,
                                        success: function (model, response) {
                                            self.collection.remove(entry);
                                        },
                                        error: function (model, response) {
                                        }
                                    });


                                } else if (customInfoImageModel == undefined && entry.attributes.id != model.attributes.id) {
                                    self.collection.remove(entry);
                                }
                            });

                            
                        }

                        self.saveImage(callbackSaveImage, imageData, imageMime);
                        
                    };
                }
            }
        });

        //FilePond.parse(document.body);
    },
    fillup: function (text) {
        if (text.length <= 1) {
            text = '0' + text;
        }
        return text;
    },
    UUID: function () {
        var lut = [];
        for (var i = 0; i < 256; i++) {
            lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
        }

        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;

        return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
            lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
            lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
            lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    },
    saveImage: function (callback, imageData, imageMime) {
        var nowLocalDate = new Date();

        var strLocalDate = nowLocalDate.getFullYear().toString() +
            this.fillup((nowLocalDate.getMonth() + 1).toString()) +
            this.fillup(nowLocalDate.getDate().toString()) +
            this.fillup(nowLocalDate.getHours().toString()) +
            this.fillup(nowLocalDate.getMinutes().toString()) +
            this.fillup(nowLocalDate.getSeconds().toString()) +
            nowLocalDate.getMilliseconds().toString();


        var filename = strLocalDate + " - " + "Test";
        var sizeType = 1;
        var sizeText = "750X750";
        var sortType = 1;
        var uuid = this.UUID();

        var changeDate = new Date();
        var strUtcDate = changeDate.getUTCFullYear().toString() + '-' +
            (changeDate.getUTCMonth() + 1) + '-' +
            changeDate.getUTCDate().toString() + ' ' +
            changeDate.getUTCHours() + ':' +
            changeDate.getUTCMinutes() + ':' +
            changeDate.getUTCSeconds() + '.';



        var tmpModel = new this.app.entities.collections.customInfoImage.model();
        //tmpModel.attributes.id = null;
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.Name = filename;
        tmpModel.attributes.ImageData = imageData;
        tmpModel.attributes.ImageMimeType = imageMime; 
        tmpModel.attributes.ImageUpdate = true;

        tmpModel.attributes.EventId = this.options.eventId;
        tmpModel.attributes.TemplateId = 0;
        tmpModel.attributes.ModuleRegion = '';
        tmpModel.attributes.ModuleDiv = '';
        tmpModel.attributes.ModuleType = 100;

        /*tmpModel.attributes.SizeType = sizeType;
        tmpModel.attributes.SizeText = sizeText;
        tmpModel.attributes.SortType = sortType;
        tmpModel.attributes.CommonId = uuid;
        tmpModel.attributes.UtcDate = strUtcDate;*/
        tmpModel.attributes.Filename = filename + '.png';

        this.app.entities.collections.customInfoImage.create(tmpModel, {
            wait: true,
            success: function (response) {
                callback(response);
            }
        });

    },
    setupMenuSingleType: function () {
        var self = this;

        this.ui.menuSingle_dropDown_GridMenuType.empty();

        var selected = '';

        self.app.entities.collections.GridMenuType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.GridMenuType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.menuSingle_dropDown_GridMenuType.append(options);
        });
    },
    setupFontawesome_iconpicker: function () {
        this.ui.menuSingle_btn_icon.attr('data-selected', this.model.attributes.FontAwesome);
        this.ui.menuSingle_btn_icon.iconpicker({
        });

        this.ui.menuSingle_btn_icon_selected_i.attr('class', '');
        this.ui.menuSingle_btn_icon_selected_i.addClass(this.model.attributes.FontAwesome);
    },
    iconSelected_menuSingle_btn_icon: function (e) {
        this.model.attributes.FontAwesome = e.iconpickerValue;
    },
    setupMenuItem: function () {
        var self = this;

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.eventId })[0];

        this.ui.menuSingle_dropDown_MenuItem.empty();

        if (this.model.attributes.MenuItem == 0) {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, 'selected = "selected"');
            self.ui.menuSingle_dropDown_MenuItem.append(options);
        }
        else {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, '');
            self.ui.menuSingle_dropDown_MenuItem.append(options);
        }

        var selected = '';



        this.options.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                selected = '';
                if (self.model.attributes.MenuItem == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.menuSingle_dropDown_MenuItem.append(options);
            }
        });
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    setModel: function () {
        this.model.set({
            MenuItem: this.ui.menuSingle_dropDown_MenuItem.val(),
            GridMenuType: this.ui.menuSingle_dropDown_GridMenuType.val(),
            Margin1_Top: this.ui.menuSingle_input_margin1_Top.val(),
            Margin1_Bottom: this.ui.menuSingle_input_margin1_Bottom.val(),
            Margin1_Left: this.ui.menuSingle_input_margin1_Left.val(),
            Margin1_Right: this.ui.menuSingle_input_margin1_Right.val(),
        });
    },
    setupCssStyle: function () {
    }
});